import React from 'react';
import './Loader.css';

const Loader = () => {
    return (
        <div className='loader'>
            <div className='ring-middle' />
            <div className='ring-inner' />
        </div>
    )
}

export default Loader;